import { render, staticRenderFns } from "./StrongCv.vue?vue&type=template&id=63c7e9f0&"
import script from "./StrongCv.vue?vue&type=script&lang=js&"
export * from "./StrongCv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports